import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import DashboardStub from '../../../../components/kea/DashboardStub';
import CardBox from '../../../../components/kea/CardBox';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function CartProducts({ withProducts }) {
  const t = useLocalizedMessage();
  const options = {
    legend: {
      display: false,
      position: 'bottom',
    },
    textYIndex: 2,
  };

  const data = {
    labels: [
      t('recs.dashboard.legend.didNotUseRecommendations'),
      t('recs.dashboard.legend.usedRecommendations'),
    ],
    datasets: [{
      data: [
        withProducts.noRecs,
        withProducts.recs,
      ],
      backgroundColor: [
        analyticsChartTheme.grid,
        analyticsChartTheme.brand,
      ],
      hoverBackgroundColor: [
        analyticsChartTheme.border,
        analyticsChartTheme.primaryDark,
      ],
    }],
    text: `${withProducts.recsPercentage}%`,
  };

  return (
    <CardBox header={t('recs.dashboard.cartProducts.title')} styleName="recs-dashboard-card">
      {
        (withProducts.error)
          ? (<DashboardStub variant="bars" />)
          : (
            <div>
              <div className="row">
                <div className="col-sm-6 donutSegment">
                  <Doughnut
                    height={230}
                    data={data}
                    options={options}
                  />
                </div>
                <div className="col-sm-6">
                  <p>
                    {withProducts.recsPercentage}
                    <IntlMessages id="ui.recs.dashboard.cartProducts.ofVisitorsWithProductsInCartUsedRecommendations" />
                    <br />
                  </p>
                </div>
              </div>
            </div>
          )
            }
    </CardBox>
  );
}

CartProducts.propTypes = {
  withProducts: PropTypes.shape({
    recsPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noRecs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    recs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.any,
  }).isRequired,
};

export default CartProducts;
